
import { AssessmentModule } from "@/types/assessment";

export const assessmentModules: AssessmentModule[] = [
  {
    id: "owner-readiness",
    title: "mySuccession Snapshot",
    description: "A comprehensive assessment to understand your current business situation, succession goals, and identify key priorities for your transition planning.",
    status: "not-started",
    estimatedTime: "5-7 minutes",
    sections: [
      {
        id: "snapshot",
        title: "Succession Snapshot",
        description: "Complete assessment of your succession planning readiness"
      }
    ]
  },
  {
    id: "owner-readiness-exit-timeline",
    title: "Owner Readiness & Exit Timeline",
    description: "Assess your personal readiness for succession and establish a realistic timeline for your business exit strategy.",
    status: "not-started",
    estimatedTime: "6-8 minutes",
    sections: [
      {
        id: "owner-readiness",
        title: "Owner Readiness Assessment",
        description: "Evaluate your readiness for transition"
      }
    ]
  },
  {
    id: "business-profile",
    title: "Business Profile",
    description: "Complete your company profile to unlock your business valuation and insights about your business operations, structure, and key performance indicators.",
    status: "not-started",
    estimatedTime: "8-10 minutes",
    sections: [
      {
        id: "business-foundation",
        title: "Business Foundation",
        description: "Core business information and structure"
      },
      {
        id: "operations-people",
        title: "Operations & People",
        description: "Team structure and key personnel"
      },
      {
        id: "business-continuity",
        title: "Business Continuity",
        description: "Risk management and succession planning"
      },
      {
        id: "ownership-control",
        title: "Ownership & Control",
        description: "Ownership structure and governance"
      }
    ]
  },
  {
    id: "business-valuation",
    title: "Business Valuation",
    description: "Understand your business value through financial analysis and market positioning assessment.",
    status: "not-started",
    estimatedTime: "10-15 minutes",
    sections: [
      {
        id: "valuation-analysis",
        title: "Valuation Analysis",
        description: "Assess your business value and market position"
      }
    ]
  },
  {
    id: "business-optimization",
    title: "Business Optimization Review",
    description: "Evaluate your business operations and identify opportunities to enhance value and operational efficiency before succession.",
    status: "not-started",
    estimatedTime: "12-15 minutes",
    sections: [
      {
        id: "optimization-analysis",
        title: "Optimization Analysis",
        description: "Review operational efficiency and value enhancement opportunities"
      }
    ]
  },
  {
    id: "advisory-team",
    title: "Advisory Team Assembly",
    description: "Build your succession advisory team with the right mix of legal, financial, and strategic expertise.",
    status: "not-started",
    estimatedTime: "8-12 minutes",
    sections: [
      {
        id: "team-assessment",
        title: "Team Assessment",
        description: "Identify and evaluate your advisory team requirements"
      }
    ]
  },
  {
    id: "financial-readiness",
    title: "Financial Readiness Assessment",
    description: "Ensure your personal and business finances are optimized for a successful succession transition.",
    status: "not-started",
    estimatedTime: "15-20 minutes",
    sections: [
      {
        id: "financial-analysis",
        title: "Financial Analysis",
        description: "Comprehensive review of financial readiness for succession"
      }
    ]
  },
  {
    id: "successor-strategy",
    title: "Successor Strategy",
    description: "Develop a comprehensive strategy for identifying, preparing, and transitioning to your chosen successor.",
    status: "not-started",
    estimatedTime: "12-18 minutes",
    sections: [
      {
        id: "successor-planning",
        title: "Successor Planning",
        description: "Strategic planning for successor identification and preparation"
      }
    ]
  },
  {
    id: "governance-family",
    title: "Governance & Family Dynamics",
    description: "Address governance structures and family dynamics that impact succession planning and business continuity.",
    status: "not-started",
    estimatedTime: "10-15 minutes",
    sections: [
      {
        id: "governance-analysis",
        title: "Governance Analysis",
        description: "Evaluate governance and family dynamics considerations"
      }
    ]
  },
  {
    id: "exit-structure",
    title: "Exit Structure & Tax Optimization",
    description: "Optimize your exit structure for tax efficiency and maximum value realization in your succession plan.",
    status: "not-started",
    estimatedTime: "15-20 minutes",
    sections: [
      {
        id: "structure-optimization",
        title: "Structure Optimization",
        description: "Design optimal exit structure and tax strategy"
      }
    ]
  },
  {
    id: "mysuccession-plan",
    title: "Comprehensive Plan Assembly",
    description: "Synthesize all assessment insights into a complete, actionable succession plan tailored to your unique situation.",
    status: "not-started",
    estimatedTime: "20-25 minutes",
    sections: [
      {
        id: "plan-assembly",
        title: "Plan Assembly",
        description: "Comprehensive succession plan development and finalization"
      }
    ]
  }
];
